import { render, staticRenderFns } from "./file_notice_detail.vue?vue&type=template&id=1443b6f7&scoped=true&"
import script from "./file_notice_detail.vue?vue&type=script&lang=js&"
export * from "./file_notice_detail.vue?vue&type=script&lang=js&"
import style0 from "./file_notice_detail.vue?vue&type=style&index=0&id=1443b6f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1443b6f7",
  null
  
)

export default component.exports